import React, { useCallback, useContext } from 'react'
import { getConfig } from '../../../../config'
import { PageContext } from '../../../../contexts/page-context'

import { useBrowserService } from '../../../../lib/hooks'
import { allInstalls } from '../../../../lib/hooks/install-eligibility'
import { DesktopOsType } from '../../../../lib/services/facade'
import { navHelper } from '../../../../lib/services/navigation'
import { gnarSpec } from '../../../../lib/tracking/gnar'
import { trackLlamaInstall } from '../../../../lib/tracking/google-tag-manager/events'
import { waitGnar } from '../../../../lib/utils/promise'
import { ButtonCta } from '../../../ui-lib/button/cta/default'
import { ButtonCtaProps } from '../../../ui-lib/button/types'
import { CtaTrackingProps } from '../types'
import { UnsupportedButton } from '../unsupported'

const config = getConfig()

const alternateLinkInstallTypes = allInstalls

interface LlamaDownloadButtonBaseProps extends Omit<ButtonCtaProps, 'onClick'>, CtaTrackingProps {}

export const LlamaDownloadButtonBase: React.FC<LlamaDownloadButtonBaseProps> = ({
  placement,
  placementInternalName,
  ...restProps
}) => {
  const { pageId, slug } = useContext(PageContext)
  const browserService = useBrowserService()

  const onClickHandler = useCallback(async () => {
    trackLlamaInstall(browserService.isWindows ? DesktopOsType.Windows : DesktopOsType.Mac, placement)
    await waitGnar(gnarSpec.installLlamaButtonClick(pageId, slug, placement, placementInternalName))
    navHelper.navigateFunnelPath(config.paths.funnel.llamaDownloadDirect)
  }, [browserService.isWindows, pageId, slug, placement, placementInternalName])

  return <ButtonCta {...restProps} onClick={onClickHandler} />
}

export const LlamaUnsupportedOSButton: React.FC<ButtonCtaProps> = (props) => {
  return <UnsupportedButton {...props} alternateLinkInstallTypes={alternateLinkInstallTypes} />
}
